import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fav-chart-card" }
const _hoisted_2 = { class: "fav-apt-head" }
const _hoisted_3 = { class: "fav-apt-name" }
const _hoisted_4 = { class: "fav-apt-gu" }
const _hoisted_5 = { class: "apt-chart-grid" }
const _hoisted_6 = { class: "sub-title" }
const _hoisted_7 = { class: "chart-box" }
const _hoisted_8 = { class: "summary" }
const _hoisted_9 = { class: "summary-item" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "s-label" }, "총 거래", -1)
const _hoisted_11 = { class: "s-value" }
const _hoisted_12 = { class: "summary-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "s-label" }, "평균 금액", -1)
const _hoisted_14 = { class: "s-value accent" }
const _hoisted_15 = { class: "recent-trades" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "rt-head" }, "최근 실거래", -1)
const _hoisted_17 = {
  key: 0,
  class: "rt-empty"
}
const _hoisted_18 = { class: "rt-date" }
const _hoisted_19 = { class: "rt-area" }
const _hoisted_20 = { class: "rt-floor" }
const _hoisted_21 = { class: "rt-amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.apt.aptNm), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.guName(_ctx.apt.sggCd)), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaTypes, (areaType) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "chart-container",
          key: areaType
        }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(areaType === "small" ? "60㎡ 이하 (소형)" : "60㎡ 초과 (중대형)"), 1),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.chartData[areaType])
              ? (_openBlock(), _createBlock(_component_LineChart, {
                  key: 0,
                  class: "chart",
                  data: _ctx.chartData[areaType],
                  options: _ctx.chartOptions
                }, null, 8, ["data", "options"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getMoneyFormat(_ctx.totalCount[areaType])) + "건", 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.avgAmount[areaType].toFixed(1)) + "억", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            (_ctx.recentDeals[areaType].length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 거래 내역이 없습니다. "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentDeals[areaType], (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'recent-' + index,
                class: "rt-row"
              }, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(item.dealYear) + "." + _toDisplayString(_ctx.pad(item.dealMonth)) + "." + _toDisplayString(_ctx.pad(item.dealDay)), 1),
                _createElementVNode("span", _hoisted_19, [
                  _createTextVNode(_toDisplayString(item.excluUseAr) + "㎡ ", 1),
                  _createElementVNode("em", null, _toDisplayString(_ctx.toPyeong(item.excluUseAr)) + "평", 1)
                ]),
                _createElementVNode("span", _hoisted_20, _toDisplayString(item.floor) + "층", 1),
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.toEok(item.dealAmount)) + "억", 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["rt-status", item.cdealType === 'O' ? 'cancel' : 'normal'])
                }, _toDisplayString(item.cdealType === 'O' ? '해제' : '정상'), 3)
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}